import React, { Fragment, useState, useEffect, useLayoutEffect } from 'react';
import { MoreHorizontal } from 'react-feather';
import Leftbar from './LeftBar';
import Rightbar from './RightBar';
import Searchbar from './Search';
import { Row } from 'reactstrap';
import { useContext } from 'react';
import CustomizerContext from '../../_helper/Customizer';
import Profile from '../Sidebar/Profile';
import LogoutClass from './RightBar/Logout';
import { NavLink } from 'react-router-dom';
import { HomeIcon } from 'lucide-react';
import { IoHomeOutline } from "react-icons/io5";
import { FiShoppingBag } from "react-icons/fi";
import { FaRegClock } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa";
import { FaRegQuestionCircle } from "react-icons/fa";

const Header = () => {
    const [sidebartoogle, setSidebartoogle] = useState(true);
    const { toggleIcon, toggleSidebarResponsive, setToggleIcon } = useContext(CustomizerContext);
    const [toggle, setToggle] = useState(true);

    function useWindowSize() {
        const [size, setSize] = useState([0, 0]);
        useLayoutEffect(() => {
            function updateSize() {
                setSize([window.innerWidth, window.innerHeight]);
                if (window.innerWidth <= 991) {
                    setToggleIcon(true);
                } else {
                    setToggleIcon(false);
                }
            }
            window.addEventListener('resize', updateSize);
            updateSize();
            return () => window.removeEventListener('resize', updateSize);
        }, []);
        return size;
    }
    // eslint-disable-next-line
    const [width] = useWindowSize();

    useEffect(() => {
        if (window.innerWidth <= 991) {
            setToggleIcon(true);
        } else {
            setToggleIcon(false);
        }
    }, []);

    const toggleResp = (value) => {
        setToggle(value);
        toggleSidebarResponsive(toggle);
    };
    const [isMob, setisMob] = useState(false);

    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    return (
        <Fragment>
            <div className={`page-main-header ${toggleIcon ? 'close_icon' : ''}`}>
                <div className='container'>
                    <div className="main-header-right m-0 d-flex align-items-center">
                        {/* <Leftbar sidebartoogle={sidebartoogle} setSidebartoogle={setSidebartoogle} /> */}
                        {/* <Searchbar /> */}
                        <div className='main-logo'>
                            <a href='#' className='text-xl font-bold'>GPS</a>
                        </div>
                        <div className="nav-right col right-menu p-0 d-flex" >
                            <div id="sidebar-menu" className={`menu-block ${isMob ? 'active' : ''}`}>
                                {/* <SidebarMenuItems props={props} sidebartoogle={sidebartoogle} setNavActive={setNavActive} /> */}
                                <ul className='nav-menu custom-scrollbar list-group'>
                                    <li>
                                        <NavLink className="text-sm" to="/dashboard/default">
                                            <IoHomeOutline />
                                            Dashboard
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="text-sm" to="/buy">
                                            <FiShoppingBag />
                                            Buy Device</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="text-sm" to="/order-list"><FaRegClock /> Order History</NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="text-sm" to="/profile">
                                            <FaRegUser />
                                            Profile
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink className="text-sm" to="/help">
                                            <FaRegQuestionCircle />
                                            Help
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div className='simple-list d-flex flex-row nav-menus'>
                                <Profile />
                                <LogoutClass />
                                <div className={`overflow-bg ${isMob ? 'active' : ''
                                    }`} onClick={() => onChangeBodyClass(!isMob)}>
                                </div>
                                <div
                                    className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                    onClick={() => onChangeBodyClass(!isMob)}
                                >
                                    <div
                                        className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                            }`}
                                    >
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="d-lg-none mobile-toggle pull-right w-auto" onClick={() => toggleResp(!toggle)}>
                            <MoreHorizontal />
                        </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
};

export default Header;